import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs/Observable';
import { CookieProvider } from './cookie.provider';
import { AO_AUTH_URL, SSO_COOKIE_NAME, USE_COOKIE } from '~auth/providers/auth.provider';

@Injectable()
export class AoCookieProvider extends CookieProvider {
  PING_TIMER = 58 * 60;

  constructor(
    private http: HttpClient,
    cookieService: CookieService, @Inject(SSO_COOKIE_NAME) cookieName: string, @Inject(AO_AUTH_URL) protected AO_URL: string, @Inject(USE_COOKIE) protected useCookie: string) {
    super(cookieService, cookieName);
  }

  isAuthenticated() {
    return !this.useCookie || super.isAuthenticated();
  }

  ping(): Observable<boolean> {
    return this.http.post(`${this.AO_URL}/app/auth`, null, {
      withCredentials: true,
      observe: 'response',
      responseType: 'text'
    })
      .take(1)
      .map(res => res.status === 200)
      .catch(() => Observable.of(false));
  }

  signOut() {
    if (!this.useCookie) return Observable.of(true);

    // this.clearCookie(); -- This wont remove the cookie, need to call signout to remove the cookie.
    // .map().catch() exception on signout is not working as excepted
    this.http.get(`${this.AO_URL}/j_spring_security_logout`, { withCredentials: true })
      .take(1)
      .subscribe();

    return Observable.of(true);
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/providers/ao-cookie.provider.ts